import React, { useState } from 'react';
import { LOCATIONS, BRANDING } from '../config';
import '../global/styles.css';

function HamburgerMenu({ isAdmin = false, onLogout, onNavigate }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigate = (location) => {
    onNavigate(location);
    setIsOpen(false);
  };

  const handleLogout = () => {
    onLogout();
    setIsOpen(false);
  };

  // Get unique location types that actually have locations
  const locationTypes = [...new Set(LOCATIONS.map(loc => loc.type))];

  // Format type name for display (capitalize first letter)
  const formatTypeName = (type) => {
    return type.charAt(0).toUpperCase() + type.slice(1) + 's';
  };

  return (
    <>
      {/* Hamburger Button */}
      <button
        className={`menu-toggle ${isOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <div className="hamburger-lines">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      {/* Overlay */}
      {isOpen && <div className="menu-overlay" onClick={toggleMenu}></div>}

      {/* Menu Panel */}
      <div className={`menu-panel ${isOpen ? 'open' : ''}`}>
        <div className="menu-header">
          <h3 className="title-auth">{BRANDING.companyName}</h3>
          <button className="btn-close" onClick={toggleMenu}>X</button>
        </div>

        <div className="menu-content">
          {/* Navigation Section */}
          <div className="menu-section">
            <h4 className="section-title">Navigation</h4>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('home')}
            >
              Home Dashboard
            </button>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('daily-dashboard')}
            >
              Daily Dashboard
            </button>
          </div>

          {/* Locations Section - Dynamic from config */}
          <div className="menu-section">
            <h4 className="section-title">Locations</h4>

            {locationTypes.map(type => {
              const typeLocations = LOCATIONS.filter(loc => loc.type === type);
              if (typeLocations.length === 0) return null;

              return (
                <div className="menu-group" key={type}>
                  {locationTypes.length > 1 && (
                    <h5 className="menu-group-label">{formatTypeName(type)}</h5>
                  )}
                  {typeLocations.map(location => (
                    <button
                      key={location.id}
                      className="btn btn-secondary btn-full menu-item-compact"
                      onClick={() => handleNavigate(location.id)}
                    >
                      {location.name}
                    </button>
                  ))}
                </div>
              );
            })}
          </div>

          {/* Accountability Forms Section */}
          <div className="menu-section">
            <h4 className="section-title">Accountability Forms</h4>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('accountability-forms')}
            >
              Complete Usage Form
            </button>
          </div>

          {/* DEA Forms Section */}
          <div className="menu-section">
            <h4 className="section-title">DEA Forms</h4>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('dea-forms')}
            >
              DEA Form 41
            </button>
          </div>

          {/* ProtocolTrack Section */}
          <div className="menu-section">
            <h4 className="section-title">ProtocolTrack</h4>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('protocol-quizzes')}
            >
              Protocol Quizzes
            </button>
            {isAdmin && (
              <>
                <button
                  className="btn btn-secondary btn-full menu-item-compact"
                  onClick={() => handleNavigate('protocol-quizzes-admin')}
                >
                  Manage Quizzes
                </button>
                <button
                  className="btn btn-secondary btn-full menu-item-compact"
                  onClick={() => handleNavigate('protocol-document')}
                >
                  Protocol Document
                </button>
              </>
            )}
          </div>

          {/* Settings Section */}
          <div className="menu-section">
            <h4 className="section-title">Settings</h4>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('profile')}
            >
              Profile
            </button>
            {isAdmin && (
              <button
                className="btn btn-secondary btn-full menu-item-compact"
                onClick={() => handleNavigate('admin-dashboard')}
              >
                Admin Dashboard
              </button>
            )}
            <button
              className="btn btn-primary btn-full menu-item-logout"
              onClick={handleLogout}
            >
              Log Out
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default HamburgerMenu;
